import {useLocation} from 'react-router-dom'
import {useGTMDispatch} from '../analytics/react-gtm-hook/index'

export const useVirtualPageview = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendVirtualPageviewData = (pagePath, query) => {
    const categoryTitleArray = pagePath.split('/')
    const pageTitle = categoryTitleArray[categoryTitleArray.length - 1]
    const formattedPageTitle = pageTitle
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .replace(/ And /g, ' & ')
    const formattedQuery = query.toLowerCase()

    setTimeout(() => {
      try {
        sendDataToGTM({
          event: 'virtual_pageview',
          ecommerce: {
            page_path: pagePath,
            page_title: formattedPageTitle,
            search_term: formattedQuery,
          },
        })
      } catch (error) {
        console.error('useVirtualPageview error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendVirtualPageviewData
}

/**
 * Maps a calendar tab's dayText and tab index to analytics tab_name.
 * Future Day N uses tabIndex (0-based position in deliverySlotArray).
 */
export const getBookDeliveryTabName = (dayText, tabIndex) => {
  if (dayText === 'Today') return 'Same Day'
  if (dayText === 'Tomorrow') return 'Next Day'
  return `Future Day ${tabIndex}`
}

/**
 * Maps a calendar tab to virtual_page_path matching the Book Delivery URL query param.
 * All days after Today use type=nextDay (same as calendar tab navigation).
 */
export const getBookDeliveryVirtualPagePath = (dayText) => {
  if (dayText === 'Today') return '/book-delivery?type=sameDay'
  return '/book-delivery?type=nextDay'
}

export const useBookDeliveryVirtualPageView = () => {
  const sendDataToGTM = useGTMDispatch()

  const sendBookDeliveryVirtualPageView = ({tabName, virtualPagePath}) => {
    setTimeout(() => {
      try {
        sendDataToGTM({
          event: 'virtual_page_view',
          virtual_page_path: virtualPagePath,
          virtual_page_title: 'Book Delivery',
          tab_name: tabName,
          page_type: 'Book Delivery',
        })
      } catch (error) {
        console.error('useBookDeliveryVirtualPageView error within setTimeout: ' + error.message)
      }
    }, 0)
  }

  const trackCalendarTab = (tabIndex, dayText) => {
    sendBookDeliveryVirtualPageView({
      tabName: getBookDeliveryTabName(dayText, tabIndex),
      virtualPagePath: getBookDeliveryVirtualPagePath(dayText),
    })
  }

  const trackRapidDelivery = () => {
    sendBookDeliveryVirtualPageView({
      tabName: 'Rapid',
      virtualPagePath: '/book-delivery?type=rapid',
    })
  }

  return {trackCalendarTab, trackRapidDelivery}
}

export const usePageDataTracking = () => {
  const location = useLocation()
  const sendDataToGTM = useGTMDispatch()

  const sendPageData = (pageType, pageCategory, pageSubCategory) => {
    if (!pageType) return
    setTimeout(() => {
      sendDataToGTM({
        event: 'page_view',
        pagePath: location.pathname + location.search,
        pageType: pageType,
        pageCategory: pageCategory,
        pageSubCategory: pageSubCategory,
        timestamp: new Date().toISOString(),
      })
    }, 0)
  }

  return sendPageData
}
